// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = theme => ({
  mainInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    color: GlobalStyles.color.COLOR_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    [theme.breakpoints.down(600)]: {
      color: GlobalStyles.color.COLOR_BLACK_GREY,
      marginTop: 10,
    },
  },
  boldFont: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
});

export default styles;
